import { UploadedPolicyDocument } from './uploaded-policy-document.interface';

export interface DocumentBox {
  documentBoxType: DocumentTypeEnum;
  documentBoxTitle: string;
  documentBoxImg?: string;
  uploaded?: boolean;
  documents?: UploadedPolicyDocument[];
}

export enum DocumentTypeEnum {
  registryNo = 'Technical Docs',
  policy = 'Application',
  invoice = 'Invoice',
}

export enum UploadType {
  policyTechnicalDocs = 'POLICY_TECHNICAL_DOCS',
  policyApplication = 'POLICY_APPLICATION',
  policyInvoice = 'POLICY_INVOICE',
}

export interface DocumentBoxUploadBody {
  uploadType: UploadType;
  file: FormData;
}

export interface DocumentBoxDoc {
  filename: string;
  type?: string;
  info?: string;
  contents: string; // Contents should be Base64 encoded.
}
